/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'

/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION SITE THEME SECTION - COLORS - COLOR PALETTE: STYLES --------------- ++++++++++ */
export default theme => ({
  colorpalette: {
    display: 'flex',
    justifyContent: 'space-between',
    '& .colorpalettewrap': {
      display: 'grid',
      gridTemplateColumns: 'repeat(30, 10px)',
      maxWidth: pxToEm(120),
      '& .color': {
        width: pxToEm(16),
        height: pxToEm(16),
        borderRadius: '100%'
      }
    }
  }
});
